import { DrawDeadlineConfig } from '@/config/game';

export const deadlinesDrawToDrawDays = (
  drawDeadlines: readonly DrawDeadlineConfig[]
): string[] => {
  return drawDeadlines.reduce((prev, current) => {
    return [...prev, current.day];
  }, []);
};
